<template>
  <section class="success">
    <assurance :activation="activeAssureur" v-if="activeAssureur" @oga="retourAssurance"/>
    <popup-base
      v-show="wantToMakeOffer"
      class="w-full"
      @clickOnBackground="logState"
    >
      <div class="cardinal">
        <div class="success-container h-full ">
          <div class="text-left flex pl-6 pr-6">
            <div class="text-c24 font-c7 w-4/5">
              Nouveau client
            </div>

            <div class="w-1/5 flex justify-end">
              <icon
                :data="icons.fermer"
                height="30"
                width="30"
                class="cursor-pointer"
                original
                @click="fermer"
              />
            </div>
          </div>

          <div class="text-c18 font-c4 mt-6 bg-white p-6 pb-12">
            <div class="text-left text-c14 font-c5 mt-2">
              INFORMATION D'IDENTITÉ
            </div>

            <div class="flex mt-10">
              <inputo
                class="w-1/2"
                placeholder="Nom *"
                @info="retourNom"
              />
              <inputo
                class="w-1/2 ml-6"
                placeholder="Prénom *"
                @info="retourPrenom"
              />
            </div>

            <div class="flex mt-6">
              <div class="w-1/2">
                <datepicker
                  placeholder="Date de naissance"
                  :max-date="new Date()"
                  min-date="01/01/1900"
                  start-date="01/01/1900"
                  :choseTime="false"
                  format="dd-MM-yyyy"
                  @info="retourDate"
                />
              </div>
              <div class="w-1/2 ml-6">
                <multiselect
                  :value-t="sexe"
                  background="white"
                  :option="optionSexe"
                  @info="retourSexe"
                />
              </div>
            </div>

            <div class="flex mt-6">
              <inputo
                class="w-1/2"
                placeholder="Profession *"
                @info="retourProfession"
              />
              <inputo
                class="w-1/2 ml-6"
                placeholder="Entreprise"
                @info="retourEntreprise"
              />
            </div>

            <div class="flex mt-6">
              <inputo
                class="w-1/2"
                placeholder="Ville"
                @info="retourVille"
              />
              <inputo
                class="w-1/2 ml-6"
                placeholder="Adresse"

                @info="retourAdresse"
              />
            </div>

            <div class="flex mt-6 items-center">
              <div class="w-1/2">
                <multiselect
                    :value-t="clientType"
                    background="white"
                    :option="optionType"
                    @info="retourType"
                />
              </div>
              <div class="w-1/2 ml-6 text-left flex items-center text-90">
                <icon
                    :data="icons.ic_agence"
                    v-if="valueAssurance !== null && clientType === 'Client partenaire'"
                    height="40"
                    width="40"
                    class="cursor-pointer"
                    original
                />

                <div v-if="valueAssurance !== null && clientType === 'Client partenaire'" class="ml-2 text-c14">
                  {{valueAssurance.name}}
                </div>
              </div>
            </div>

            <div class="text-left text-c14 font-c5 mt-10">
              CONTACT
            </div>

            <div class="flex mt-6">
              <div class="w-1/2">
                <inputo
                  placeholder="Email"
                  type="email"
                  @info="retourEmail"
                />

                <phoneNumber
                  class="mt-6"
                  :max="30"
                  placeholder="Whatsapp"
                  @info="retourWhatsapp"
                />
              </div>

              <div class="w-1/2 ml-6">
                <div class="flex items-center">
                  <phoneNumber
                    class="w-4/5"
                    :max="30"
                    placeholder="Telephone *"
                    @info="retourTelephone"
                  />
                  <div class="w-1/5 ml-6">
                    <div
                      class="w-10 h-10 rounded-50 add flex items-center justify-center cursor-pointer"
                      @click="plus"
                    >
                      <div class="text-c18">
                        +
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  v-for="(item, index) in addSession"
                  :key="index"
                  class="mt-4"
                >
                  <add-phone
                    :index="index"
                    @info="retourPhone"
                  />
                </div>
              </div>
            </div>

            <div class="text-left text-43 text-c12 flex items-center mt-12">
              <div>Facebook</div>
              <div class="ml-6">
                <switcher @info="retourFacebook" />
              </div>
              <div class="ml-6 w-1/2" v-if="activeFacebook">
                <inputo placeholder="Lien Facebook" @info="retourFac" />
              </div>
            </div>

            <div class="text-left text-43 text-c12 flex items-center mt-6">
              <div>Linkedin</div>
              <div class="ml-6">
                <switcher @info="retourLinkedin" />
              </div>
              <div class="ml-6 w-1/2" v-if="activeLinkedin">
                <inputo placeholder="Lien Linkedin" @info="retourLin"/>
              </div>
            </div>

            <div class="text-left text-43 text-c12 flex items-center mt-6">
              <div>Instagram</div>
              <div class="ml-6">
                <switcher @info="retourTelegram" />
              </div>
              <div class="ml-6 w-1/2" v-if="activeTelegram">
                <inputo placeholder="Lien Instagram" @info="retourTel"/>
              </div>
            </div>

            <div class="text-left text-43 text-c12 flex items-center mt-6">
              <div>Twitter</div>
              <div class="ml-6">
                <switcher @info="retourTwitter" />
              </div>
              <div class="ml-6 w-1/2" v-if="activeTwitter">
                <inputo placeholder="Lien Twitter" @info="retourTwi"/>
              </div>
            </div>


            <div class="mt-12">
              <textare
                placeholder="Note"
                radius="5px"
                size="14px"
                border="1px solid #DDDDDD"
                @info="retourNote"
              />
            </div>

            <div class="flex items-center text-left mt-6">
              <div class="w-1/5">
                <upload height="109px" @info="retourFile"/>
              </div>

              <div class="w-5/6 pl-6">
                <div class="text-c18 font-c5">
                  Photo de profil
                </div>
                <div class="text-90 text-c16 mt-2 w-4/5">
                  Non obligatoire. Merci de ne pas déranger le client pour cela
                </div>
              </div>
            </div>

            <div
              v-if="error !== null"
              class="mt-6 text-red text-c14"
            >
              {{ error }}
            </div>
          </div>

          <div class="flex pl-6 pr-6 bg-white pb-10">
            <div class="w-1/2">
              <buton
                background="#C4C4C4"
                color="#000000"
                label="Annuler"
                height="55px"
                :charge="charge"
                @oga="fermer"
              />
            </div>

            <div class="w-1/2 ml-6">
              <buton
                label="Enregistrer"
                height="55px"
                :charge="charge"
                @oga="continuer"
              />
            </div>
          </div>
        </div>
      </div>
    </popup-base>
  </section>
</template>

<script>
import PopupBase from '../helper/add/popupBase2'
import buton from '../helper/add/button'
import ic_agence from '../../assets/icons/agency.svg'
import fermer from '../../assets/icons/fermer.svg'
import inputo from '../helper/form/input'
import datepicker from '../helper/form/datePicker'
import phoneNumber from '../helper/form/phoneNumber'
import http from "../../plugins/https"
import apiroutes from "../../router/api-routes"
import addPhone from "../cdevs/clients/addphone"
import multiselect from '../helper/form/multiselect'
import switcher from '../helper/form/switcher'
import textare from '../helper/form/textarea'
import upload from '../helper/form/upload2'
import assurance from './assurances'

export default {
  name: 'Success',
  components: { assurance, PopupBase, buton, inputo, phoneNumber, addPhone, datepicker, multiselect, switcher, textare, upload },

  props: {
    activation: {
      type: Boolean,
      default: false
    },
    donne: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: null
    },
    steep: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      donnes: null,
      wantToMakeOffer: false,
      icons: {
        ic_agence,
        fermer
      },
      telephone: '',
      nom: '',
      adresse: '',
      error: null,
      charge: false,
      email: '',
      addSession: [],
      sexe: 'Sexe *',
      optionSexe: ['Masculin', 'Feminin'],
      naissance: '',
      prenom: '',
      entreprise: '',
      ville: '',
      activeFacebook: false,
      activeTelegram: false,
      activeLinkedin: false,
      activeTwitter: false,
      whatsapp: '',
      facebook: '',
      telegram: '',
      linkedin: '',
      twitter: '',
      profession: '',
      note: '',
      clientType: 'Type de client *',
      optionType: ['Client direct', 'Client partenaire', 'Client prospecté'],
      activeAssureur: false,
      valueAssurance: null,
      url: null,
      file: null
    }
  },

  created() {
    this.wantToMakeOffer = this.activation
    this.valueType = this.type
  },

  methods: {
    retourType(answer) {
      this.clientType = answer
      if (answer === 'Client partenaire') {
        this.activeAssureur = true
      }
    },

    retourAssurance (answer) {
      if (answer !== false) {
        this.valueAssurance = answer
      }
      this.activeAssureur = false
    },

    fermer () {
      this.$emit('oga', false)
    },

    retourFile (answer) {
      this.file = answer
    },

    plus () {
      this.addSession.push('')
    },

    async continuer() {
      this.charge = true
      this.error = null
      if (this.nom.length > 0 && this.prenom.length > 0 && this.telephone.length > 0 && this.sexe !== 'Sexe *' && this.profession.length > 0) {
        let body = {
          name: this.nom,
          surname: this.prenom,
          sex: "M",
          birthday: this.naissance,
          enterprise: this.entreprise,
          profession: this.profession,
          city: this.ville,
          address: this.adresse,
          email: this.email,
          phone: this.telephone,
          whatsapp: this.whatsapp,
          facebook: this.facebook,
          linkedin: this.linkedin,
          instagram: this.telegram,
          twitter: this.twitter,
          meta: {},
          note: this.note,
          type: 'DIRECT'
        }
        if (this.sexe === this.optionSexe[1]) {
          body.sex = 'F'
        }

        if (this.clientType === 'Client partenaire') {
          body.type = 'PARTNER'
          body.insurance = this.valueAssurance.id
        }

        if (this.clientType === 'Client prospecté') {
          body.type = 'PROSPECTED'
        }

        if (this.file !== null) {
          await this.saveFile()
        }

        if (this.url !== null) {
          body.meta.urlProfile = this.url
        }


        this.save(body)
      } else {
        this.charge = false
        this.error = 'Veuillez remplir les champs obligatoire pour continuer'
      }
    },

    save (body) {
      http.post(apiroutes.baseURL + apiroutes.createClient, body)
          .then(response => {
            this.$emit('oga', response)
            if (this.steep !== null){
              this.$store.dispatch('saveDevisUser', response)
              window.location.reload()
            }
            if (this.note !== '') {
              this.saveEvent (response)
            }
            this.charge = false
          })
          .catch(error => {
            this.charge = false
            console.log(error)
            this.error = "Problème de connexion. Veuillez ressayer"
          })
    },

    saveEvent (client) {
      http.post(apiroutes.baseURL + apiroutes.createEvent, {
        client: client.id,
        date: new Date(),
        type: "NOTE",
        note: this.note
      })
          .then(response => {
            console.log('note')
            console.log(response)
            this.charge = false
          })
          .catch(error => {
            this.charge = false
            console.log(error)
            this.error = "Problème de connexion. Veuillez ressayer"
          })
    },

    //Ici j'enregistre les fichiers et je récupère des url
    async saveFile () {
      this.charge = true
      let data = new FormData()
      data.append('files', this.file)
      let config = {
        header : {
          'Content-Type' : 'multipart/form-data'
        }
      }

      await http.post(apiroutes.baseURL + apiroutes.upload, data, config)
          .then(response => {
            console.log('file')
            console.log(response)
            this.url = response[0].url
          })
          .catch(error => {
            console.log(error)
          })
    },

    retourNote(answer){
      this.note = answer
    },

    retourNom (answer) {
      this.nom = answer
    },
    retourPrenom (answer) {
      this.prenom = answer
    },
    retourDate (answer) {
      this.naissance = answer
    },
    retourSexe (answer) {
      this.sexe = answer
    },
    retourVille (answer) {
      this.ville = answer
    },
    retourEntreprise (answer) {
      this.entreprise = answer
    },

    retourProfession (answer) {
      this.profession = answer
    },
    logState () {
      // this.wantToMakeOffer = answer
      // this.$emit('oga', false)
    },

    retourAdresse (answer) {
      this.adresse = answer
    },

    retourTelephone (answer) {
      this.telephone = answer
    },

    retourPhone (answer) {
      this.addSession[answer.index] = answer.phoneNumber
    },

    retourEmail (answer) {
      this.email = answer
    },

    retourTel(answer){
      this.telegram = answer
    },

    retourFac(answer){
      this.facebook = answer
    },

    retourLin(answer){
      this.linkedin = answer
    },
    retourTwi(answer){
      this.twitter = answer
    },

    retourFacebook (answer) {
      this.activeFacebook = answer
    },

    retourTwitter (answer) {
      this.activeTwitter = answer
    },

    retourLinkedin (answer) {
      this.activeLinkedin = answer
    },

    retourWhatsapp (answer) {
      this.whatsapp = answer
    },

    retourTelegram (answer) {
      this.activeTelegram = answer
    },
  }
}
</script>

<style lang="scss"  scoped>
    @import "../../assets/styles/sass/mixin";
    .success {
      z-index: 999;
    }
    .cardinal {
      width: 100%;
    }

    .add{
      background-color: #ECECEC;
    }

    .success-container {
      font-family: $font-default;
      width: 100%;
      background-color: #F5F5F5;
      height: 100vh;
      max-height: 100vh;
      overflow-x: hidden;
      overflow-y: scroll;
      margin: auto;
    }
    @media screen and (max-width: 700px){
      .success-container {
        width: 100%;
        height: 100vh;
      }
      .titre {
        font-size: 18px;
      }
      .bloc1 {
        width: 100%;
      }
      .bloc2 {
        width: 100%;
        font-size: 18px;
      }
      .button {
        width: 100%;
        font-size: 16px;
      }
      .cardinal {
        width: 100%;
      }
    }

    @media screen and (max-width: 1024px) and (min-width: 770px){
      .cardinal{
        width: 65%;
      }
      .titre{
        font-size: 18px;
      }
      .button{
        width: 100%;
        height: 55px;
        font-size: 19px;
      }
    }

    @media screen and (max-width: 769px) and (min-width: 701px){
      .cardinal{
        width: 90%;
      }
      .titre{
        font-size: 18px;
      }
      .button{
        width: 100%;
        height: 55px;
        font-size: 19px;
      }
    }
    @media screen and (max-width: 320px){
      .cardinal{
        width: 100%;
      }
      .titre{
        font-size: 14px;
      }
      .button{
        width: 100%;
        height: 55px;
        font-size: 15px;
      }
    }
</style>
